import React from "react";
import Navigation from "../../navigation/Navigation";

/**
 * This page presents the user with information on what project they have been allocated along with who their markers are and what times their
 * presentations are at.
 * @returns the details of the final allocation the student got
 */

function ViewFinalAllocation() {
    return(
        <div className="finalAllocationContainer">
            <Navigation/>
            <h1>Final Allocation</h1>
        </div>
    )
}

export default ViewFinalAllocation